<span *ngIf="doctor">({{doctor.get('DoctorDisplayName')}})</span>